function printAuthor(author) {
	if ( 0 < Number(author) ) {
		// check if capAlgolia.authors[author] is defined
		if ( 'undefined' === typeof capAlgolia.authors[author] ) {
			return '';
		}
		const authorName = capAlgolia.authors[author].name;
		const authorLink = capAlgolia.authors[author].link;
		return `<a href="${authorLink}" title="Aurelia Glass" target="_self">${authorName}</a>`;
	} else {
		return `<span>${author}</span>`;
	}
}

export default printAuthor;